/* tslint:disable */
import {
  Player,
  GameCategory
} from '../index';

declare var Object: any;
export interface PlayerGameCategoryInterface {
  "id"?: any;
  "playerId"?: any;
  "categoryId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  player?: Player;
  category?: GameCategory;
}

export class PlayerGameCategory implements PlayerGameCategoryInterface {
  "id": any;
  "playerId": any;
  "categoryId": any;
  "createdAt": Date;
  "updatedAt": Date;
  player: Player;
  category: GameCategory;
  constructor(data?: PlayerGameCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerGameCategory`.
   */
  public static getModelName() {
    return "PlayerGameCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerGameCategory for dynamic purposes.
  **/
  public static factory(data: PlayerGameCategoryInterface): PlayerGameCategory{
    return new PlayerGameCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerGameCategory',
      plural: 'player-game-categories',
      path: 'player-game-categories',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'any'
        },
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "categoryId": {
          name: 'categoryId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
        category: {
          name: 'category',
          type: 'GameCategory',
          model: 'GameCategory',
          relationType: 'belongsTo',
                  keyFrom: 'categoryId',
          keyTo: 'id'
        },
      }
    }
  }
}
